var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.005 20.29c0 2.641 4.391 4.71 9.997 4.71S20 22.931 20 20.29V4.71C20 2.069 15.607 0 9.998 0 4.392 0 0 2.069 0 4.71c0 2.948.005-7.83.005 15.58zM9.998 9.42c2.837 0 6.992-.646 9.017-2.637v3.11c0 .003-.003.006-.003.01 0 1.792-3.621 3.71-9.012 3.71-5.368 0-8.979-1.902-9.01-3.687V6.778C3.025 8.773 7.146 9.42 9.998 9.42zM.99 11.966c1.598 1.578 4.986 2.647 9.01 2.647 4.028 0 7.419-1.07 9.015-2.652l-.001 3.135c0 .833-.755 1.51-1.386 1.93-1.701 1.115-4.552 1.78-7.626 1.78C4.615 18.806.995 16.89.99 15.1v-3.134zM10.002 24C4.612 24 .99 22.082.99 20.29v-3.133c1.597 1.58 4.986 2.649 9.012 2.649 2.834 0 6.993-.63 9.013-2.628v3.112c0 1.792-3.622 3.71-9.013 3.71zM9.998 1c5.393 0 9.017 1.918 9.017 3.71S15.39 8.42 9.998 8.42c-2.933 0-8.436-.787-9.013-3.71C.985 2.918 4.607 1 9.998 1z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.c5777a5460b0d23545920bc921965224.svg";
export { ForwardRef as ReactComponent };